export const getNodes = (state: any) => state.dependencyVisualization.processState.nodes;
export const getEdges = (state: any) => state.dependencyVisualization.processState.edges;
export const getResourceNodes = (state: any) =>
    state.dependencyVisualization.processState.resources;
export const getSelectedResources = (state: any) => state.dependencyVisualization.selectedResources;
